'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TheScoreContentCardSource = require('./TheScoreContentCardSource');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TheScoreContentCardSource).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }